import { DatePicker } from "antd";
import locale from "antd/locale/fr_FR";
import classnames from "classnames";
import Label from "shared/components/Label";

const { RangePicker } = DatePicker;

const Simple = ({
  label,
  errors,
  touched,
  icon,
  required,
  onChange,
  ...rest
}) => {
  const handleChange = (dates, dateStrings) => {
    if (!onChange) return;
    if (!dates) return onChange(null, dateStrings);

    const start = rest.showTime
      ? dates[0]?.second(0).millisecond(0)
      : dates[0]?.startOf("day");
    const end = rest.showTime
      ? dates[1]?.second(0).millisecond(0)
      : dates[1]?.endOf("day");
    const normalizedDates = [start, end];
    onChange(normalizedDates, dateStrings);
  };

  return (
    <div
      className={classnames("datepicker__wrapper", {
        __error: touched && errors,
      })}
    >
      <Label label={label} icon={icon} required={required} />
      <div className={`datepicker__wrapper--field`}>
        <RangePicker
          locale={locale}
          className={classnames({ "disabled--input": rest.disabled })}
          onChange={handleChange}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

export default Simple;
